import { Checkbox, Select } from "antd";
import moment from "moment";
import { FiFileText, FiPlus } from "react-icons/fi";
import ReactQuill from "react-quill";
import { Button, Card, CardBody, Col, Container, Row, Spinner, Table } from "reactstrap";
import notFound from "../../assets/imgs/not-found.png";
import QuoteItemCard from "../../components/cards/QuoteItemCard";
import BackButton from "../../components/button/BackButton";
import OrderBillingAddressCard from "../../components/cards/OrderBillingAddressCard";
import OrderShippingAddressCard from "../../components/cards/OrderShippingAddressCard";
import SaleOrderTotalCard from "../../components/cards/SaleOrderTotalCard";
import FormInput from "../../components/formInput/FormInput";
import AddOrderItem from "../../components/modals/AddOrderItem";
import PageName from "../../components/react_helmet/PageName";
import useManualQuote from "./customHooks/useManualQuote";
import OrderDetailsSkeleton from "../../components/skeleton/OrderDetailsSkeleton";
import { orderTerms } from "../../data";
const ManualQuote = (props) => {
    const {
        billingData,
        setBillingData,
        shippingData,
        setShippingData,
        gsaContract,
        handleCheckboxChange,
        line_items,
        setLineItems,
        itemModal,
        toggleItemModal,
        totalTaxAmount,
        setTotalTaxAmount,
        subTotal,
        totalAmount,
        proceedClick,
        shippingCheckboxes,
        setShippingCheckboxes,
        state,
        history,
        addQuoteNotes, note, setNote, dataLoading,
        notes, setNewLineItems, totalTax, loading, expiryDate, setExpiryDate, handleShippingCheckboxChange, sameAsBilling, setSameAsBilling, terms, setTerms
    } = useManualQuote(props);
    if (dataLoading) {
        return (
            <div className="mt-4">
                <OrderDetailsSkeleton isQuote={true} />
            </div>
        );
    }
    return (
        <>
            <AddOrderItem
                toggle={toggleItemModal}
                modal={itemModal}
                setLineItems={setLineItems}
                line_items={line_items}
                setNewLineItems={setNewLineItems}
            />
            <PageName title={`${state ? "Edit Quote" : "Add Quote"}`} />
            <Container fluid className="px-4 py-3">
                <div className="mb-3 d-flex justify-content-end">
                    <BackButton handleClick={() => history.goBack()} />
                </div>
                <div className="d-flex justify-content-between align-items-start mb-4 bg-white p-3 rounded-3 shadow-sm border">
                    <div className="d-flex align-items-center gap-3">
                        <div className="bg-primary-soft p-2 rounded-3 text-primary">
                            <FiFileText size={24} />
                        </div>
                        <div>
                            <h4 className="fw-bold text-dark mb-0">{state ? "Edit Quote" : "Create New Quote"}</h4>
                            <p className="text-muted mb-0 fs-13">Manage quote details, items, and internal notes</p>
                        </div>
                    </div>
                    <div className="d-flex gap-4">
                        <div className="d-flex flex-column align-items-end">
                            <FormInput
                                type={'date'}
                                label={'Quote Expiry'}
                                value={expiryDate}
                                handleChange={(e) => setExpiryDate(e.target.value)}
                                customClassName="mb-0"
                            />
                        </div>
                        <div className="d-flex flex-column align-items-end">
                            <label className="fw-600 fs-13 mb-1 text-muted">Payment Terms</label>
                            <Select
                                size="large"
                                placeholder="Select Terms"
                                className="custom-antd-select"
                                style={{ width: 180 }}
                                value={terms || undefined}
                                onChange={(val) => setTerms(val)}
                                options={orderTerms?.map((term) => ({ label: term.label, value: term.value }))}
                            />
                        </div>
                        <div className="d-flex align-items-center bg-light px-3 rounded-2 border">
                            <Checkbox checked={gsaContract} onChange={handleCheckboxChange} className="me-2" />
                            <span className="fw-600 fs-13">GSA Contract # {gsaContract}</span>
                        </div>
                    </div>
                </div>

                <Row className="mb-4 gy-4">
                    <Col md={6}>
                        <OrderBillingAddressCard
                            title="Bill To"
                            billingData={billingData}
                            setBillingData={setBillingData}
                            shippingCheckboxes={shippingCheckboxes}
                            setShippingCheckboxes={setShippingCheckboxes}
                        />
                    </Col>
                    <Col md={6}>
                        <OrderShippingAddressCard
                            title="Ship To"
                            shippingData={shippingData}
                            setShippingData={setShippingData}
                            shippingCheckboxes={shippingCheckboxes}
                            setShippingCheckboxes={setShippingCheckboxes}
                            sameAsBilling={sameAsBilling}
                            setSameAsBilling={setSameAsBilling}
                            handleShippingCheckboxChange={handleShippingCheckboxChange}
                        />
                    </Col>
                </Row>

                <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="fw-bold text-dark mb-0">Product Items</h4>
                        <Button
                            color="primary"
                            outline
                            className="rounded-2 d-flex align-items-center gap-2 px-3 shadow-sm"
                            style={{ height: '40px' }}
                            onClick={toggleItemModal}
                        >
                            <FiPlus size={18} />
                            Add Item
                        </Button>
                    </div>
                    {line_items?.length > 0 ? (
                        line_items?.map((item, index) => (
                            <div className="item_body_wrapper mb-3" key={item?._id || index}>
                                <QuoteItemCard
                                    index={index}
                                    data={item}
                                    line_items={line_items}
                                    setLineItems={setLineItems}
                                    imgURL={item?.image?.src}
                                />
                            </div>
                        ))
                    ) : (
                        <Card className="border-dashed py-5 text-center bg-light">
                            <div className="opacity-50">
                                <img src={notFound} width="80" alt="Not found" className="mb-2" />
                                <p className="mb-0">No items added to this quote yet.</p>
                            </div>
                        </Card>
                    )}
                </div>

                <Row className="mb-4 d-flex align-items-stretch gy-4">
                    <Col md={8}>
                        <Card className="border-0 shadow-sm h-100">
                            <CardBody className="p-4 d-flex flex-column">
                                <div className="d-flex align-items-center gap-2 mb-3">
                                    <div className="bg-primary-soft p-2 rounded-circle text-primary">
                                        <FiFileText size={18} />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-0 fs-16">Quote Internal Notes</h5>
                                </div>

                                <div className="mb-2">
                                    <ReactQuill
                                        theme="snow"
                                        value={note}
                                        placeholder="Type internal notes or special instructions..."
                                        onChange={(e) => setNote(e)}
                                        style={{ height: '120px', marginBottom: '42px' }}
                                    />
                                </div>

                                <div className="d-flex justify-content-end mt-auto pt-3">
                                    <Button
                                        className="bg-primary-color px-4 rounded-2 fw-600 shadow-sm d-flex align-items-center gap-2"
                                        style={{ height: '42px' }}
                                        onClick={addQuoteNotes}
                                    >
                                        <FiPlus size={16} />
                                        Add Note
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <div className="d-flex flex-column h-100">
                            <SaleOrderTotalCard
                                totalTaxAmount={totalTaxAmount}
                                setTotalTaxAmount={setTotalTaxAmount}
                                subTotal={subTotal}
                                totalAmount={totalAmount}
                                discount={true}
                                totalTax={totalTax}
                            />
                            <div className="mt-auto pt-3 d-flex gap-2">
                                <Button
                                    color="secondary"
                                    outline
                                    className="w-50 rounded-2 fw-bold"
                                    onClick={() => history.goBack()}
                                    style={{ height: '42px' }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="w-50 bg-primary-color rounded-2 fw-bold shadow-sm"
                                    onClick={() => proceedClick("publish")}
                                    disabled={loading}
                                    style={{ height: '42px' }}
                                >
                                    {loading ? <Spinner size="sm" /> : (state ? 'Update Quote' : 'Create Quote')}
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>

                {notes?.length > 0 && (
                    <div className="modern-table-container mb-5">
                        <div className="settings-card shadow-sm border-0 overflow-hidden" style={{ borderRadius: '12px' }}>
                            <div className="bg-primary-soft p-3 border-bottom d-flex align-items-center gap-2">
                                <h5 className="mb-0 fw-bold text-dark fs-15">Quote Activity Logs & Notes</h5>
                                <span className="badge bg-white text-primary rounded-pill px-3 py-1 shadow-sm border">{notes?.length}</span>
                            </div>
                            <Table responsive hover bordered className="modern-table modern-table-sm mb-0">
                                <thead style={{ backgroundColor: "#00509d2E" }}>
                                    <tr>
                                        <th style={{ width: "220px" }}>Date/Author</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody className="fs-14">
                                    {notes.sort((a, b) => b.createdAt - a.createdAt).map((row, index) => (
                                        <tr key={index} style={{ background: index % 2 === 0 ? "#fdfdfd" : "white" }}>
                                            <td className="align-middle">
                                                <div className="d-flex flex-column py-1">
                                                    <span className="fw-bold text-primary fs-13">
                                                        {row.createdBy?.username || "System"}
                                                        <span className="text-muted fw-normal ms-1 fs-11">({row.createdBy?.role || "Auto"})</span>
                                                    </span>
                                                    <span className="text-muted fs-11 mt-1">
                                                        {moment(row.createdAt).format("MMM Do YYYY, h:mm a")}
                                                    </span>
                                                </div>
                                            </td>
                                            <td className="align-middle">
                                                <div
                                                    className="fs-13 text-dark lh-base py-1"
                                                    dangerouslySetInnerHTML={{ __html: row?.note ?? row?.message ?? "" }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )}



                {
                    state?.created_by && (
                        <Col md={12} className="mb-0">
                            <p className="text-end text-muted fs-12 mb-0">
                                Created By: {typeof state?.created_by === 'object' ? (state?.created_by?.name || state?.created_by?.username || "Not Available") : (state?.created_by || "Not Available")} at {moment(state?.created_at).format("MMM Do YYYY, h:mm a")}
                            </p>
                        </Col>
                    )
                }
                {
                    state?.updated_by && (
                        <Col md={12} className="mb-0">
                            <p className="text-end text-muted fs-12 mb-0">
                                Updated By: {state?.updated_by?.username ?? "Not Available"} at {moment(state?.updated_at).format("MMM Do YYYY, h:mm a")}
                            </p>
                        </Col>
                    )
                }
            </Container>

        </>
    );
};
export default ManualQuote;
